module.exports = __webpack_public_path__ + "static/media/8OLA6.14522fd3.jpg";